const ArrowDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.55"
      height="18.742"
      viewBox="0 0 14.55 18.742"
    >
      <path
        id="icon"
        d="M642.2,228.141l-6.287-6.287a.988.988,0,1,1,1.4-1.4l4.6,4.6V210.676a.988.988,0,1,1,1.975,0v14.38l4.6-4.6a.988.988,0,0,1,1.4,1.4l-6.287,6.287a.988.988,0,0,1-1.4,0Z"
        transform="translate(-635.626 -209.688)"
      />
    </svg>
  );
};

export default ArrowDownIcon;
